
export const moduleName = `reportIncident`

export const FETCH_INCIDENT_DETAILS = `${moduleName}_fetch_incident_details`
export const FETCH_INCIDENT_DETAILS_ERROR = `${moduleName}_fetch_incident_details_error`
export const FETCH_INCIDENT_DETAILS_FULFILLED = `${moduleName}_fetch_incident_details_fulfilled`

export const SAVE_INCIDENT_NOTES = `${moduleName}_save_incident_notes`
export const SAVE_INCIDENT_NOTES_ERROR = `${moduleName}_save_incident_notes_error`
export const SAVE_INCIDENT_NOTES_FULFILLED = `${moduleName}_save_incident_notes_fulfilled`
